export default "__VITE_ASSET__CzKI13lT__"